import PropTypes from "prop-types";
import "./FraudRuleViewComponent.scss";

const FraudRuleViewComponent = ({ data = {}, inputSchema = {} }) => {
  // Extract the label map from the schema definitions
  const getLabelMap = (schema) => {
    const labelMap = {};
    if (schema.definitions) {
      Object.keys(schema.definitions).forEach((key) => {
        const definition = schema.definitions[key];
        if (definition.enum) {
          definition.enum.forEach((value, index) => {
            labelMap[value] = definition.enumNames
              ? definition.enumNames[index]
              : value;
          });
        }
      });
    }
    return labelMap;
  };

  // Get the label map from the schema
  const labelMap = getLabelMap(inputSchema);

  // Helper function to get the label for a value
  const getLabel = (value) => labelMap[value] || value;

  // Dynamically render ranges based on the schema properties
  const renderRanges = () => {
    if (!inputSchema.properties) return <p>No ranges defined in the schema.</p>;

    return Object.keys(inputSchema.properties).map((rangeKey) => {
      const range = data[rangeKey];
      const rangeSchema = inputSchema.properties[rangeKey];

      if (!range) return null; // Skip if the range is not present in the data

      return (
        <div className="fraud-rules-limit-titles-values" key={rangeKey}>
          <div>
            <span className="rule-limit-title font-xs font-bold">
              {rangeSchema?.title || rangeKey}:
            </span>
          </div>
          <div>
            {rangeSchema.properties?.lower && (
              <div className="limit">
                <span className="limit-title font-xs font-bold">FROM</span>
                <span className="limit-value font-xs">
                  {range.lower !== null && range.lower !== undefined
                    ? getLabel(range.lower)
                    : "N/A"}
                </span>
              </div>
            )}
            {rangeSchema.properties?.upper && (
              <div className="limit">
                <span className="limit-title font-xs font-bold">TO</span>
                <span className="limit-value font-xs">
                  {range.upper !== null && range.upper !== undefined
                    ? getLabel(range.upper)
                    : "N/A"}
                </span>
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="fraud-rule-configs">
      <div>
        <h4 className="fraud-rule-configs-title font-small-bold">
          {inputSchema.title}
          <span className="font-xxsmall-regular required-category">
            {" (*Required)"}
          </span>
        </h4>
      </div>
      <div className="display-flex gap-8 w-100 mb-2 mt-2">
        {Object.keys(data).length === 0 ? <p>No data available.</p> : renderRanges()}
      </div>
    </div>
  );
};

FraudRuleViewComponent.propTypes = {
  data: PropTypes.object,
  inputSchema: PropTypes.object,
};

export default FraudRuleViewComponent;
